import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/services/user/model/user';
import { StorageService } from './../../services/storage/storage.service';
import { ModalCreditsBlockedComponent } from './modal-credits-blocked/modal-credits-blocked.component';

@Component({
  selector: 'app-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss'],
})
export class CreditsComponent {
  public static readonly SHOW_CREDITS = 'showCredits';

  @Input()
  user: User;

  @Input()
  showBlocked = false;

  @Input()
  set updateCredits(update) {
    if (update) {
      this.getShowCredits();
    }
  }

  showCredits: boolean = false;

  constructor(
    private storageService: StorageService,
    private modalCtrl: ModalController,
    private router: Router
  ) {
    this.getShowCredits();
  }

  getShowCredits() {
    this.storageService.get(CreditsComponent.SHOW_CREDITS).then((res) => {
      this.showCredits = res;
    });
  }

  onClickShow() {
    this.storageService.store(CreditsComponent.SHOW_CREDITS, this.showCredits);
    this.getShowCredits();
  }

  onClickExtract() {
    this.router.navigate(['home/feed/extract']);
  }

  async onClickModalBlocked() {
    const modal = await this.modalCtrl.create({
      component: ModalCreditsBlockedComponent,
    });
    await modal.present();
  }
}
